import { render, staticRenderFns } from "./ContractLagermeister.vue?vue&type=template&id=6b6a3b3a&scoped=true&lang=true"
import script from "./ContractLagermeister.vue?vue&type=script&lang=js"
export * from "./ContractLagermeister.vue?vue&type=script&lang=js"
import style0 from "./ContractLagermeister.vue?vue&type=style&index=0&id=6b6a3b3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a3b3a",
  null
  
)

export default component.exports